export default function Arthur() {
	return (
		<div className="bio">
			<h3>Arthur "LeFrance" Lafrance</h3>
			<p>META</p>
		</div>
	);
}